export default __webpack_public_path__ + "static/media/delete-reservation.9e16d1e6.svg";